"use strict";
// global LiveAPI:true
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.midi = void 0;
var fs_1 = __importDefault(require("fs"));
var jsmidgen = __importStar(require("jsmidgen"));
/**
 * Take an array of note objects to generate a MIDI file in the same location as this method is called
 * @param  {NoteObject[]} notes    Notes are in the format: {note: ['c3'], level: 127, length: 64}
 * @param  {String | null} fileName If a filename is not provided, then `music.mid` is used by default
 * If `null` is passed for `fileName`, bytes are returned instead of creating a file
 * If this method is called from a browser then it will return a HTML link that you can append in your page
 * This link will enable the generated MIDI as a downloadable file.
 * @param {Number | null} bpm If a value is provided, the generated midi file will be set to this bpm value.
 */
var midi = function (notes, fileName, bpm) {
    if (fileName === void 0) { fileName = 'music.mid'; }
    var file = createFileFromNotes(notes, bpm);
    var bytes = file.toBytes();
    if (fileName === null) {
        return bytes;
    }
    if (!fileName.endsWith('.mid')) {
        fileName = fileName + '.mid';
    }
    if (typeof window !== 'undefined' &&
        window.URL &&
        window.URL.createObjectURL) {
        return createDownloadLink(bytes, fileName);
    }
    fs_1.default.writeFileSync(fileName, bytes, 'binary');
    console.log("MIDI file generated: " + fileName + ".");
};
exports.midi = midi;
/**
 * Create a downloadable link
 * @param b
 */
var createDownloadLink = function (b, fileName) {
    // Convert bytes to array buffer
    // Accepted answer on https://stackoverflow.com/questions/35038884/download-file-from-bytes-in-javascript
    var bytes = new Uint8Array(b.length);
    for (var i = 0; i < b.length; i++) {
        var ascii = b.charCodeAt(i);
        bytes[i] = ascii;
    }
    // Create a Blob so that we can set it up with the type of file we want (for eg MIDI)
    var blob = new Blob([bytes], { type: 'audio/midi' });
    // Create a link element to be used (you can use an existing link on the page as well)
    var link = document.createElement('a');
    link.href =
        (typeof window !== 'undefined' &&
            typeof window.URL !== 'undefined' &&
            typeof window.URL.createObjectURL !== 'undefined' &&
            window.URL.createObjectURL(blob)) ||
            '';
    // Give the downloadable file a name
    link.download = fileName;
    link.innerText = 'Download MIDI file';
    return link;
};
var createFileFromNotes = function (notes, bpm) {
    var file = new jsmidgen.File();
    var track = new jsmidgen.Track();
    // set the track's bpm if it is provided
    if (typeof bpm === 'number') {
        track.setTempo(bpm);
    }
    file.addTrack(track);
    for (var _i = 0, notes_1 = notes; _i < notes_1.length; _i++) {
        var noteObj = notes_1[_i];
        var level = noteObj.level || 127;
        // While writing chords (multiple notes per tick)
        // only the first noteOn (or noteOff) needs the complete arity of the function call
        // subsequent calls need only the first 2 args (channel and note)
        if (noteObj.note) {
            if (typeof noteObj.note === 'string') {
                track.noteOn(0, noteObj.note, noteObj.length, level); // channel, pitch(note), length, velocity
                track.noteOff(0, noteObj.note, noteObj.length, level);
            }
            else {
                track.addChord(0, noteObj.note, noteObj.length, level);
            }
        }
        else {
            track.noteOff(0, '', noteObj.length);
        }
    }
    return file;
};
